import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'par-repchat-alert',
  templateUrl: './repchat-alert.component.html',
  styleUrls: ['./repchat-alert.component.scss']
})
export class RepchatAlertComponent implements OnInit {
  showAlert: boolean;
  truncateRepMsg: Boolean = false;

  private _repName: string;
  private _repMessage: string;
  private _repImage: string;

  get repName(): string {
    return this._repName;
  }

  @Input('repName')
  set repName(value: string) {
    this._repName = value;
  }

  get repMessage(): string {
    if (this._repMessage && this._repMessage.length > 50) {
      this.truncateRepMsg = true;
    } else {
      this.truncateRepMsg = false;
    }
    return this._repMessage;
  }

  @Input('repMessage')
  set repMessage(value: string) {
    this._repMessage = value;
  }

  get repImage(): string {
    return this._repImage;
  }

  @Input('repImage')
  set repImage(value: string) {
    this._repImage = value;
  }

  @Output() show: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {
    // this.repImage = '/assets/images/rep-chat-person-default.png';
  }

  toggleState(action: string) {
    this.showAlert = !this.showAlert;
    this.show.emit(action);
  }
}
